import { render, staticRenderFns } from "./KnowledgeHubAdd.vue?vue&type=template&id=222c90e1&scoped=true&"
import script from "./KnowledgeHubAdd.vue?vue&type=script&lang=js&"
export * from "./KnowledgeHubAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222c90e1",
  null
  
)

export default component.exports